module.exports = __webpack_public_path__ + "img/img51.4ea625c9.png";